export const MEDIA_GALLERY_SCRIPT_URL = "https://cms.dealeron.com/dash/dist/mediaGalleryPlugin/mediaGalleryPlugin.js";
export const MEDIA_GALLERY_IMAGE_PREFIX = "#MISCPATH#"

export const MEDIA_GALLERY_URL_FORMAT_ABSOLUTE = "https://<DEALER_URL>/<IMAGE_PATH>"
export const MEDIA_GALLERY_URL_FORMAT_MISC = "https://<DEALER_URL>/static/dealer-<DEALER_ID>/<IMAGE_PATH>"

export const MEDIA_GALLERY_TAG_MAPPING = {
    "<DEALER_URL>": "baseURL",
    "<DEALER_ID>": "dealerId",
    "<IMAGE_PATH>": "image"
}
